export default __webpack_public_path__ + "static/media/FPO.fbd0025f.png";